import { createFileRoute } from '@tanstack/react-router';

import { OwnersPage } from '@/features/owners/components/OwnersPage';

export const Route = createFileRoute('/admin/owners')({
  component: OwnersPage,
});
